<template>
  <div class="logo-container">
    <img :src="require('@/assets/images/logo.png')" alt="Logo" class="logo" />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.logo-container {
  margin-top: 40px;
  text-align: center;
}

.logo {
  width: 80%;
  height: auto;
}
</style>
